import { useState } from "react";
import {
  Pagination,
  getPaginationWindow,
} from "../../../components/Pagination";
import { QuestCard } from "../components/QuestCard";
import { QuestBoardGuide } from "../components/QuestBoardGuide";
import { QuestLayout } from "../components/QuestLayout";
import { QuestLoadState } from "../components/QuestPrimitives";
import { isAccepting, questRanks } from "../types";
import { useQuests } from "../useQuests";

export function QuestBoard() {
  const data = useQuests();
  const [status, setStatus] = useState(() => {
    const initial = new URLSearchParams(window.location.search).get("status");
    return initial === "accepting" || initial === "closed" ? initial : "all";
  });
  const [rank, setRank] = useState("all");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const filtered = data.quests
    .filter((quest) => {
      const open = isAccepting(quest);
      return (
        (status === "all" || (status === "accepting" ? open : !open)) &&
        (rank === "all" || quest.rank === rank) &&
        `${quest.title} ${quest.company} ${quest.requiredSkills.join(" ")}`
          .toLocaleLowerCase()
          .includes(query.trim().toLocaleLowerCase())
      );
    })
    .sort(
      (a, b) =>
        Number(isAccepting(b)) - Number(isAccepting(a)) ||
        a.questNumber - b.questNumber,
    );
  const pagination = getPaginationWindow(filtered.length, page, 12);
  const singleQuest = data.quests.length === 1 && filtered.length === 1;
  return (
    <QuestLayout current="board">
      <header className="jq-board-heading content-width">
        <p className="jq-eyebrow">AIYSS JOB QUEST / CHOOSE YOUR CHALLENGE</p>
        <div className="jq-board-ribbon">
          <span className="jq-guild-mark" aria-hidden="true">
            Q<span>AIYSS</span>
          </span>
          <h1>
            クエスト掲示板<span>QUEST BOARD</span>
          </h1>
        </div>
        <p>
          企業から届いた依頼書から、次の挑戦を選ぼう。
          <br />
          掲載されているQuestは、学生向けの実際の業務委託案件です。
        </p>
      </header>
      <section className="content-width jq-board" aria-label="Quest一覧">
        {false && (
          <div className="jq-filters">
            <label className="jq-search">
              <span>SEARCH / キーワード</span>
              <input
                type="search"
                placeholder="Quest名・企業名・スキルで探す"
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                  setPage(1);
                }}
              />
            </label>
            <label>
              <span>STATUS / 募集状態</span>
              <select
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                  setPage(1);
                }}
              >
                <option value="all">すべてのQuest</option>
                <option value="accepting">Accepting / 募集中</option>
                <option value="closed">Closed / 募集終了</option>
              </select>
            </label>
            <label>
              <span>QUEST RANK / 難易度</span>
              <select
                value={rank}
                onChange={(e) => {
                  setRank(e.target.value);
                  setPage(1);
                }}
              >
                <option value="all">すべての難易度</option>
                {Object.keys(questRanks).map((r) => (
                  <option key={r} value={r}>
                    Rank {r}
                  </option>
                ))}
              </select>
            </label>
          </div>
        )}
        <details className="jq-rank-guide">
          <summary>
            Quest Rankについて{" "}
            <span>学生の能力ではなく、Questの難易度です</span>
          </summary>
          <dl>
            {Object.entries(questRanks).map(([key, label]) => (
              <div key={key}>
                <dt>{key}</dt>
                <dd>{label}</dd>
              </div>
            ))}
          </dl>
        </details>
        <QuestLoadState {...data} />
        {data.status === "ready" && (
          <>
            <div className="jq-noticeboard">
              <div className="jq-board-count" role="status">
                <div>
                  <span>POSTED REQUESTS / 掲載依頼</span>
                  <strong>
                    {String(filtered.length).padStart(2, "0")}
                    <small>件</small>
                  </strong>
                </div>
                <p>気になる依頼書を開いてみよう。</p>
              </div>
              {filtered.length > 0 ? (
                <div
                  className={`jq-card-grid${singleQuest ? " is-single" : ""}`}
                >
                  {filtered
                    .slice(pagination.startIndex, pagination.endIndex)
                    .map((quest) => (
                      <QuestCard key={quest.questNumber} quest={quest} />
                    ))}
                  {singleQuest && <QuestBoardGuide />}
                </div>
              ) : (
                <div className="jq-empty">
                  <p className="jq-eyebrow">NO QUESTS YET</p>
                  <h2>
                    {data.quests.length === 0
                      ? "新しいQuestを準備しています。"
                      : "条件に合うQuestがありません。"}
                  </h2>
                  <p>
                    {data.quests.length === 0
                      ? "公開されると、このボードに依頼が届きます。"
                      : "検索キーワードや絞り込み条件を変えてみてください。"}
                  </p>
                  {data.quests.length > 0 && (
                    <button
                      className="jq-button is-secondary"
                      onClick={() => {
                        setQuery("");
                        setRank("all");
                        setStatus("all");
                        setPage(1);
                      }}
                    >
                      条件をリセット
                    </button>
                  )}
                </div>
              )}
              <p className="jq-board-footnote">
                応募後は企業による選考があります。AIYSSは推薦・選考を行いません。
              </p>
            </div>
            <Pagination
              currentPage={pagination.page}
              totalItems={filtered.length}
              pageSize={12}
              itemUnit="件"
              ariaLabel="Quest一覧のページ切り替え"
              onPageChange={setPage}
            />
          </>
        )}
      </section>
    </QuestLayout>
  );
}
